import React, { Component } from 'react';
import './AdminOrderDetail.css';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import AdminOrderData from '../Components/AdminOrderData/AdminOrderData';
import AdminOrderTable from '../Components/AdminOrderTable/AdminOrderTable';
import barcode from '../../../image/bar-code.svg'
import iconpen from '../../../image/iconpen.svg'
import { Link } from 'react-router-dom';
import { QRCode } from "react-qr-svg";
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import axios from 'axios';
import { LinkAPI } from '../../../API/API';
import HandleRes from '../../Components/HandleRes/HandleRes';

class AdminOrderDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataorders: [],
            recivernamenew:'',
            reciverphonenew:'',
             
            deliverynote: "",
            weight: "",
            pickupdate: "",
            date:"",
            quantity: "",
            pickupaddress_name: "",
            dropoffaddress_name: "",
            orderPrice: '',
            status: '',
            totalPrice: '',
            ordernumber: '',
            qrcode: '',
            selectpickupcourier: 'select pick up courier',
            selectdeliverycourier: 'select delivery courier',
            failedstatus:Number,
            failedreason: '',
            failedreasonerror: '',
            radiobtn: false,
            getnearstpickupcourier: [],
            getnearstdeliverycourier: [],
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,

        };
        const id = this.props.match.params.id
        this.getorderid(id)
        this.getorders()

    }
    getorders=()=> {
        const Token = localStorage.getItem("AdminTokenKayn")

        axios.get(`${LinkAPI}/api/admin/getorders`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                dataorders: res.data.reverse(),
            })
        }).catch(error => {
            this.HandleError(error)

        })
    }
    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            window.location.replace("/Admin/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message,
                failedreasonerror: '',

            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }
    setStateField = e => {
        this.setState({
            failedreason: e.target.value,
            radiobtn: false,

        })
    }
    setStateField2 = e => {
        this.setState({
            failedreason: e.target.value,

        })
    }
    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
            failedreason: ''
        });

    };
    getorderid = (x = this.props.match.id) => {
        const Token = localStorage.getItem("AdminTokenKayn")
        const id = x
        axios.get(`${LinkAPI}/api/admin/getorder/${id}`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
console.log(res)
            this.setState({
                reciver: res.data.order.reciver,
                quantity: res.data.order.quantity,
                ordernumber: res.data.order.ordernumber,
                deliverynote: res.data.order.note,
                pickupdate: res.data.order.pickupDate,
                date: res.data.order.date,
                pickupaddress_name: res.data.order.pickupLocation.address_name,
                pickupaddress_alias: res.data.order.pickupLocation.address_alias,
                totalPrice: res.data.order.totalPrice,
                status: res.data.order.status,
                failedstatus:res.data.order.failedstatus,
                amount: res.data.order.amount,
                qrcode: res.data.order.qrcode,
                failedreason: res.data.order.failedreason,
                ownerData_name:res.data.order.ownerData.name,
                ownerData_phone:res.data.order.ownerData.phone,
                usecompanyinfo:res.data.order.ownerData.usecompanyinfo,
                companyname:res.data.order.ownerData.companyinfo.companyname,
                companyphone:res.data.order.ownerData.companyinfo.phone,

                // selectpickupcourier: res.data.pickupCourierData[0].name,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError: false,
                failedreasonerror: ''
            })     

            const indexrecivernew = res.data.order.reciver.length - 1
            const indexreciverold = res.data.order.reciver.length - 2
            const indexdropoffLocationnew = res.data.order.dropoffLocation.length - 1
            const indexdropoffLocationold = res.data.order.dropoffLocation.length - 2
                if(res.data.order.reciver.length===1&&res.data.order.dropoffLocation.length===1){
                    this.setState({
                        recivernamenew: res.data.order.reciver[indexrecivernew].name,
                        reciverphonenew: res.data.order.reciver[indexrecivernew].phone,
                        dropoffLocationnamenew: res.data.order.dropoffLocation[indexdropoffLocationnew].address_name,
                        dropoffLocationaliasnew: res.data.order.dropoffLocation[indexdropoffLocationnew].address_alias,
                    })
                }else if(res.data.order.reciver.length>1){
                    this.setState({
                        recivernamenew: res.data.order.reciver[indexrecivernew].name,
                        reciverphonenew: res.data.order.reciver[indexrecivernew].phone,
                        recivernameold: res.data.order.reciver[indexreciverold].name,
                        reciverphoneold: res.data.order.reciver[indexreciverold].phone,
                        dropoffLocationnamenew: res.data.order.dropoffLocation[indexdropoffLocationnew].address_name,
                        dropoffLocationaliasnew: res.data.order.dropoffLocation[indexdropoffLocationnew].address_alias,
                        dropoffLocationnameold: res.data.order.dropoffLocation[indexdropoffLocationold].address_name,
                        dropoffLocationaliasold: res.data.order.dropoffLocation[indexdropoffLocationold].address_alias
                    })
                }
                else if(res.data.order.dropoffLocation.length>1){
                    this.setState({
                        recivernamenew: res.data.order.reciver[indexrecivernew].name,
                        reciverphonenew: res.data.order.reciver[indexrecivernew].phone,
                        dropoffLocationnamenew:res.data.order.dropoffLocation[indexdropoffLocationnew].address_name,
                        dropoffLocationaliasnew:  res.data.order.dropoffLocation[indexdropoffLocationnew].address_alias
                    })
                }
            const indexpickup = res.data.order.pickupCourierData.length - 1
            const indexdelivery = res.data.order.deliveryCourierData.length - 1

            if (res.data.order.pickupCourierData.length !== 0) {
                this.setState({
                    selectpickupcourier: res.data.order.pickupCourierData[indexpickup].name
                })
            } else {
                this.setState({
                    selectpickupcourier: 'select pick up courier'
                })
            }
            if (res.data.order.deliveryCourierData.length !== 0) {
                this.setState({
                    selectdeliverycourier: res.data.order.deliveryCourierData[indexdelivery].name
                })
            } else {
                this.setState({
                    selectdeliverycourier: 'select delivery courier'
                })
            }
            this.getcouriers(id)
            this.getorders()

        }).catch(error => {
            this.HandleError(error)

        })
        
    }
    getcouriers=(x)=>{
        const Token = localStorage.getItem("AdminTokenKayn")
        const id = x
        if(this.state.status===1||this.state.status===2){

            axios.get(`${LinkAPI}/api/admin/getnearstpickupcourier/${id}`, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
                this.setState({
                    getnearstpickupcourier: res.data,
                    networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
                })
                // console.log(res)
    
            }).catch(error => {
                this.HandleError(error)
    
            })}
            if(this.state.status===4&&this.state.failedstatus!==1||this.state.status===5&&this.state.failedstatus!==1){
            axios.get(`${LinkAPI}/api/admin/getnearstdeliverycourier/${id}`, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
                this.setState({
                    getnearstdeliverycourier: res.data,
                    networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
                })
                // console.log(res.data)
    
            }).catch(error => {
                this.HandleError(error)
    
            })}
    }
    validate = () => {
        let failedreasonerror = "";
        if ( !isNaN(this.state.failedreason)||this.state.failedreason.length<2) {
            failedreasonerror = "write failed reason ";
        }
        if (failedreasonerror) {
            this.setState({ failedreasonerror });
            return false;
        }
        return true;
    };
    Assignpickupcourier = (object) => e => {
        const Token = localStorage.getItem("AdminTokenKayn")
        axios.post(`${LinkAPI}/api/admin/assignPickupCourier`, {
            courier_id: object,
            ordernumber: this.state.ordernumber
        }, {
            headers: {
                Authorization: `${Token}`
            }
        }
        ).then(res => {
            const id = this.props.match.params.id
            this.getorderid(id)
            this.getorders()
            this.setState({
                networkError: false,
        errordatamessage: false,
        errordatamessagetext: '',
        hasError: false,
            })
        }).catch(error => {
            this.HandleError(error)

        })
    }
    Assigndeliverycourier = (object) => e => {
        const Token = localStorage.getItem("AdminTokenKayn")
        axios.post(`${LinkAPI}/api/admin/assignDeliveryCourier`, {
            courier_id: object,
            ordernumber: this.state.ordernumber
        }, {
            headers: {
                Authorization: `${Token}`
            }
        }
        ).then(res => {
            const id = this.props.match.params.id
            this.getorderid(id)
            this.getorders()

            this.setState({
                networkError: false,
        errordatamessage: false,
        errordatamessagetext: '',
        hasError: false,
            })
            
        }).catch(error => {
            this.HandleError(error)

        })
    }
    handelEditReason = () => {
        const { failedreason } = this.state
        const Token = localStorage.getItem("AdminTokenKayn")
        const id = this.props.match.params.id
        const isValid = this.validate();
        if (isValid) {
            axios.put(`${LinkAPI}/api/admin/modifyorder/${id}`, {
                failedreason: failedreason,
                status: 8,
                failedstatus:1
            }, {
                headers: {
                    Authorization: `${Token}`
                }
            }
            ).then(res => {
                this.setState({
                    res_failedone:true,
                    networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
                }) 
                setTimeout(() => {
                    this.setState({
                        res_failedone:false
                    })
            }, 2000);
            }).catch(error => {
                this.HandleError(error)

            })
        }
    }
    print=()=>{
        var content = document.getElementById("divcontents");
        var pri = document.getElementById("ifmcontentstoprint").contentWindow;
        pri.document.open();
        pri.document.write('<style> .col-md-6   {width: 50%;display: inline-block} p  {font-size: 20px;  display: inline-block;  font-family: tahoma;}  button  ,.Receiverde  {visibility: hidden;} </style>');
        pri.document.write(content.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
    }
    render() {
        const paramsordernumber = this.props.match.params.id
        return (
            <div className="AppEN">
                <div className="row  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarAdmin />
                    </div>
                    <div className=" AdminOrderDetail col-md-11 px-4">
                        <AdminHeaderTool />
                        <div className="row p-1">
                            <AdminOrderTable state={this.state} getorderid={this.getorderid.bind(this)} paramsordernumber={paramsordernumber} />
                            <div className="col-md-8 px-lg-5 py-3"> 
                                <AdminOrderData old={this.old} state={this.state} Assignpickupcourier={this.Assignpickupcourier.bind(this)} Assigndeliverycourier={this.Assigndeliverycourier.bind(this)} />
                                <div className="col-md-12 d-flex justify-content-around flex-wrap">
                                    <Link to={"/Admin/EditOrder/" + this.state.ordernumber}> <button className="btn badge-pill p-2 pl-1 px-3 m-1 border shadow bg-white"><img className="mr-1" src={iconpen} alt="iconpen" /> MODIFY ORDER</button></Link>
                                    <button className="btn badge-pill p-2 pl-1 px-3 m-1  border shadow bg-white" data-toggle="modal" data-target="#done"><img className="mx-1" src={barcode} alt="barcode" />PRINT LABEL</button>
                                    {(this.state.status>3&&this.state.status!==7?
                                    <button className="btn badge-pill p-2 pl-1 px-3 m-1  border shadow bg-white" data-toggle="modal" data-target="#ORDER-FAILED">ORDER FAILED</button>
                                :'')
                                                                        }
                                    </div>
                                {/* Modal  */}
                                <div className="modal fade  " id="ORDER-FAILED" tabIndex="-1" role="dialog" aria-labelledby="ORDER-FAILED" aria-hidden="true">
                                    <div className="modal-dialog  " role="document">
                                        <div className="modal-content border shadow">
                                            <div className="modal-body col-8 mx-auto p-lg-5">
                                                <p className="fontsize4">Failed delivery reason</p>
                                                <div className="form-check m-3 ">
                                                    <input className="form-check-input " type="radio" name="radiobtn" id="reason1" value="Client is not home" onChange={this.setStateField} />
                                                    <label className="form-check-label fontsize12 font-weight-bold" htmlFor="reason1">
                                                        Client is not home
                                        </label>
                                                </div>
                                                <div className="form-check m-3">
                                                    <input className="form-check-input " type="radio" name="radiobtn" id="reason2" value="Call was not answered" onChange={this.setStateField} />
                                                    <label className="form-check-label fontsize12 font-weight-bold" htmlFor="reason2">
                                                        Call was not answered
                                        </label>
                                                </div>
                                                <div className="form-check m-3 ">
                                                    <input className="form-check-input " type="radio" name="radiobtn" id="reason3" value="Order was rejected" onChange={this.setStateField} />
                                                    <label className="form-check-label fontsize12 font-weight-bold" htmlFor="reason3" id="reason3" >
                                                        Order was rejected
                                        </label>
                                                </div>
                                                <div className="form-check m-3 ">
                                                    <input className="form-check-input " type="radio" name="radiobtn" onClick={this.handleChange} />

                                                    <input className="form-control badge-pill col-10  fontsize12" type="text" name="failedreason2" onChange={this.setStateField2} disabled={(this.state.radiobtn ? '' : 'disabled')} />
                                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.failedreasonerror}
                                                    </div>
                                                </div>
                                                <button type="button" onClick={this.handelEditReason} className="btn  bg-white badge-pill text-dark my-3 mx-auto px-lg-5 shadow" data-dismiss={(this.state.failedreasonerror ? '' : 'modal')}>SEND REASON</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal fade  " id="done" tabIndex="-1" role="dialog" aria-labelledby="done" aria-hidden="true">
                                    <div className="modal-dialog  " id="divcontents"role="document">
                                        <div className="modal-content border shadow">
                                            <div className="modal-body col-12 mx-auto p-lg-4 ">
                                                {/* <img className="m-2  " src={iconrightgreen} alt="close" />
                                                <p className="fontsize4">Order status changed</p> */}
                                                <div className="row pt-3" >
                                                    <div className="row  col-md-6  border-right">
                                                        {(this.state.usecompanyinfo?
                                                            <div>
                                                               <p className="fontsize11  font-weight-bold Receiverde">Receiver details</p>

                                                                <div className="col-12 ">
                                                                    <p className=" fontsize12 text-muted">Reciever :</p>
                                                                    <p className="fontsize11 ">{this.state.recivernamenew}</p>

                                                                </div>
                                                                <div className="col-12  ">
                                                                    <p className=" fontsize12 text-muted">Phone number : </p>
                                                                    <p className="fontsize11 ">{this.state.reciverphonenew}</p>

                                                                </div>
                                                                <div className="col-12  ">
                                                                    <p className=" fontsize12 text-muted">Company Name :</p>
                                                                        <p className="fontsize11 ">{this.state.companyname}</p>

                                                                </div>
                                                                <div className="col-12  ">
                                                                    <p className=" fontsize12 text-muted">Company Phone :</p>
                                                                    <p className="fontsize11 ">{this.state.companyphone}</p>

                                                                </div>
                                                            </div>
                                                        :
                                                            <div>
                                                                <div className="col-12 ">
                                                                <p className=" fontsize12 text-muted">Reciever :</p>	
                                                                <p className="fontsize11 ">{this.state.recivernamenew}</p>

                                                                </div>
                                                                <div className="col-12  ">
                                                                    <p className=" fontsize12 text-muted">Phone number :</p>	
                                                                    <p className="fontsize11 ">{this.state.reciverphonenew}</p>

                                                                </div>
                                                                <p className="fontsize11  font-weight-bold ml-3">Sender details</p>
                                                                <div className="col-12 ">
                                                                <p className=" fontsize12 text-muted">name :</p>
                                                                <p className="fontsize11 ">{this.state.ownerData_name}</p>

                                                                </div>
                                                                <div className="col-12  ">
                                                                    <p className=" fontsize12 text-muted">Phone :</p>
                                                                    <p className="fontsize11 ">{this.state.ownerData_phone}</p>

                                                                </div>
                                                            </div>
                                                    )}
                                                    </div>
                                                    <div className="col-md-6 text-center ">
                                                        <div className="mx-auto">
                                                            <QRCode
                                                                bgColor="#FFFFFF"
                                                                fgColor="#000000"
                                                                level="Q"
                                                                style={{ width: 180 }}
                                                                value={this.state.qrcode}
                                                            />
                                                        </div>
                                                    </div>


                                                </div>
                                                <div className="text-center">
                                                    <button type="button" className="btn btn-primary  badge-pill  my-3 mx-auto px-lg-5 shadow" onClick={this.print} >PRINT</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <iframe id="ifmcontentstoprint" style={{
                                    height: '0px',
                                    width: '0px',
                                    position: 'absolute',
                                    visibility: 'hidden'
                                }}><hr/></iframe> 
                                
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.res_failedone ? <HandleRes title="order status has been changed" stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default AdminOrderDetail;